import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TripLogInitialValues, TripLogInterface } from '../../models/dashboard/trip-log/trip-log';

type TripLogStateItem = TripLogInterface & { id: string; };

const createTripLogStateItem = (tripLog: TripLogInterface): TripLogStateItem => ({
  ...tripLog,
  id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
});

const getInitialState = () => ({
  tripLogSize: 1,
  tripLogs: [createTripLogStateItem(TripLogInitialValues)],
});

interface IInitialState {
  tripLogSize: number;
  tripLogs: TripLogStateItem[];
}

interface UpdateTripLogPayload {
  id: string;
  tripLog: TripLogInterface;
}

const initialState: IInitialState = getInitialState();

const createTripLogSlice = createSlice({
  name: 'createTripLog',
  initialState,
  reducers: {
    setTripLogs(state, action: PayloadAction<TripLogInterface>) {
      state.tripLogs = [...state.tripLogs, createTripLogStateItem(action.payload)];
      state.tripLogSize = state.tripLogs.length;
    },

    addEmptyTripLog(state) {
      state.tripLogs = [...state.tripLogs, createTripLogStateItem(TripLogInitialValues)];
      state.tripLogSize = state.tripLogs.length;
    },

    updateTripLogsAtId(state, action: PayloadAction<UpdateTripLogPayload>) {
      state.tripLogs = state.tripLogs.map((tripLog) => {
        if (tripLog.id === action.payload.id) {
          return {
            ...tripLog,
            ...action.payload.tripLog,
          };
        }

        return tripLog;
      });
    },

    deleteTripLogsAtId(state, action: PayloadAction<string>) {
      state.tripLogs = state.tripLogs.filter((tripLog) => tripLog.id !== action.payload);
      state.tripLogSize = Math.max(1, state.tripLogs.length);
    },

    reset: () => getInitialState(),
  },
});

export const createTripLogActions = createTripLogSlice.actions;
export default createTripLogSlice.reducer;
